export default __webpack_public_path__ + "static/media/back.b7165dcc.svg";